import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import useDetailHandler from '../../hooks/useDetailHandler';
import { onActionKey } from '../../utils';
import {
    holidayPropertiesType,
    holidayYearType,
} from '../../types';
import './_styles_/HolidayRow.css';
import HolidayDetailTab from './HolidayDetailTab';
import DateTime, { SHORT_DATE } from '../DateTime';

HolidayRow.propTypes = {
    holidayYear: holidayYearType.isRequired,
    holidayProps: holidayPropertiesType.isRequired,
};

function HolidayRow(props) {
    const {
        holidayYear,
        holidayProps,
    } = props;
    const { isDetailVisible, toggleDetail } = useDetailHandler(holidayYear.year);
    return (
        <>
            <div className="rich-list-row holiday-header" onClick={toggleDetail} onKeyUp={onActionKey(toggleDetail)} role="button" tabIndex={0}>
                <div className="rich-list-row--arrow-mobile">
                    <FontAwesomeIcon icon={`caret-${isDetailVisible ? 'down' : 'right'}`} />
                </div>
                <div className="holidays-header--values--year">{holidayYear.year}</div>
                <div className="holidays-header--values--dates">{
                    holidayYear.holidays.map((holiday) => (
                        <span key={holiday.id}><DateTime value={holiday.holidayDate} format={SHORT_DATE} />&nbsp;</span>
                    ))
                }
                </div>
                <div className="rich-list-row--arrow">
                    <FontAwesomeIcon icon={`caret-${isDetailVisible ? 'down' : 'right'}`} />
                </div>
            </div>
            {isDetailVisible && (
                <HolidayDetailTab holidayYear={holidayYear} holidayProps={holidayProps} />
            )}
        </>
    );
}

export default HolidayRow;
